import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import ReportResult from "./ReportResult";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "react-loader-spinner";
import {DecryptED} from "../../DecryptJS/Decrypt"
const AdminWeeklyReport = () => {
    const classes = useStyles();
    const { sid, userid } = useParams();
    const storageKey = `admin_weeklyplan_state_${sid}_${userid}`;
    const [apiloader, setapiLoader] = useState(false);
    const [isCalled, setIsCalled] = useState(false);
    const [hasRestored, setHasRestored] = useState(false);
    const [reports, setReports] = useState([]);
    const [teachers, setTeachers] = useState([]);
    const [classList, setClassList] = useState([]);
    const [selectedTeacherOption, setSelectedTeacherOption] = useState("default");
    const [selectedClassOption, setSelectedClassOption] = useState("default");
    const [inputData, SetInputData] = useState({
        "sid": DecryptED(sid),
        "userId": DecryptED(userid),
        "staff": [],
        "class_id": [],
        "startDate": "",
        "endDate": "",
        "page": 1,
        "pageSize": 10

    });

    const handleSubmit = async () => {
        setapiLoader(true);
        try {
            const response = await axios(
                {
                    method: "POST",
                    url: `${process.env.REACT_APP_BASE_URL}/api/admin/weeklyPlan/all/report`,
                    data: inputData,
                    headers: {
                        Authorization: "#$laksdfnlknoea#$@$%^&%$",
                    }
                }
            );
            setReports(response.data.data || []);
        } catch (error) {
            Swal.fire({
                position: "center",
                icon: "warning",
                title: (error.response && error.response.data && error.response.data.message) || "Could not load reports",
                showConfirmButton: false,
                timer: 1500,
            });
        } finally {
            setapiLoader(false);
        }
    }

    const getTeachers = async () => {
        try {
            const data = {
                "sid": DecryptED(sid),
                "userId": DecryptED(userid)
            }
            const response = await axios({
                method: "POST",
                url: `${process.env.REACT_APP_BASE_URL}/api/admin/weeklyPlan/teachers`,
                data,
                headers: {
                    Authorization: "#$laksdfnlknoea#$@$%^&%$",
                },
            });
            setTeachers(response.data || []);
        } catch (error) {
            Swal.fire({
                position: "center",
                icon: "warning",
                title: (error.response && error.response.data && error.response.data.message) || "Could not load teachers",
                showConfirmButton: false,
                timer: 1500,
            });
        }
    }

    const getClasses = async () => {
        try {
            const data = {
                "sid": DecryptED(sid),
                "userId": DecryptED(userid)
            }
            const response = await axios({
                method: "POST",
                url: `${process.env.REACT_APP_BASE_URL}/api/admin/weeklyPlan/class`,
                data,
                headers: {
                    Authorization: "#$laksdfnlknoea#$@$%^&%$",
                },
            });
            setClassList(response.data || []);
        } catch (error) {
            Swal.fire({
                position: "center",
                icon: "warning",
                title: (error.response && error.response.data && error.response.data.message) || "Could not load classes",
                showConfirmButton: false,
                timer: 1500,
            });
        }
    }

    const InsertTeachers = (e) => {
        setSelectedTeacherOption(e);
        if (e === 'SELECT_ALL') {
            SetInputData({ ...inputData, staff: teachers.map((t) => t.staff_id) });
        } else {
            SetInputData({ ...inputData, staff: [e] })
        }
    }

    const InsertClasses = (e) => {
        setSelectedClassOption(e);
        if (e === 'SELECT_ALL') {
            SetInputData({ ...inputData, class_id: classList.map((c) => c.class_id) });
        } else {
            SetInputData({ ...inputData, class_id: [e] })
        }
    }

    useEffect(() => {
        getTeachers();
        getClasses();

        try {
            const saved = sessionStorage.getItem(storageKey);
            if (saved) {
                const parsed = JSON.parse(saved);
                if (parsed.inputData) SetInputData(parsed.inputData);
                if (parsed.reports) setReports(parsed.reports);
                if (parsed.selectedTeacherOption) setSelectedTeacherOption(parsed.selectedTeacherOption);
                if (parsed.selectedClassOption) setSelectedClassOption(parsed.selectedClassOption);
                setIsCalled(true);
            }
        } catch (e) {
            console.error(e);
        }
        setHasRestored(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(isCalled){
            handleSubmit();
        }
        else{
            setIsCalled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputData.page])

    useEffect(() => {
        if (!hasRestored) return;
        try {
            sessionStorage.setItem(storageKey, JSON.stringify({
                inputData,
                reports,
                selectedTeacherOption,
                selectedClassOption,
            }));
        } catch (e) {
            console.error(e);
        }
    }, [hasRestored, inputData, reports, selectedTeacherOption, selectedClassOption, storageKey])

    return (
        <div className={classes.mainDiv}>
            <div className={classes.heading}>
                <h3
                    style={{
                        color: "#42A0EA",
                        padding: "8px 12px",
                        fontWeight: "550",
                        fontSize: "22px",
                        marginTop: "2%"
                    }}
                >
                    Weekly Reports
                </h3>
            </div>
            <div className="container">
                <div className={classes.filterCard}>
                    <form className={classes.form} onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                        <div className="row">

                            <div className="col-md-6 col-lg-3 mb-3">
                                <label className={classes.label} htmlFor="teachers">
                                    TEACHERS
                                </label>
                                <select className={classes.input} id="teachers" name="teachers" value={selectedTeacherOption} onChange={(e) => InsertTeachers(e.target.value)}>
                                    <option value="default">SELECT TEACHERS</option>
                                    <option value={'SELECT_ALL'}>SELECT ALL</option>
                                    {
                                        teachers.length ?
                                            teachers.map((Teach, index) => (<option value={Teach.staff_id} key={index}>{Teach.Teacher}</option>))
                                            : <option value="none">NO DATA</option>
                                    }
                                </select>
                            </div>

                            <div className="col-md-6 col-lg-3 mb-3">
                                <label className={classes.label} htmlFor="classes">
                                    CLASSES
                                </label>
                                <select className={classes.input} id="classes" name="classes" value={selectedClassOption} onChange={(e) => InsertClasses(e.target.value)}>
                                    <option value="default">SELECT CLASS</option>
                                    <option value={'SELECT_ALL'}>SELECT ALL</option>
                                    {
                                        classList.length ? classList.map((item, index) => (
                                            <option value={item.class_id} key={index}>{item.div_name}</option>
                                        ))
                                            : <option value="none">NO DATA</option>
                                    }
                                </select>
                            </div>

                            <div className="col-md-6 col-lg-3 mb-3">
                                <label className={classes.label} htmlFor="fromDate">
                                    Start Date
                                </label>
                                <input
                                    className={classes.input}
                                    id="fromDate"
                                    type="date"
                                    onChange={(e) => SetInputData({ ...inputData, startDate: e.target.value })}
                                    name="fromDate"
                                    value={inputData.startDate}
                                    max={inputData.endDate || undefined}
                                />
                            </div>

                            <div className="col-md-6 col-lg-3 mb-3">
                                <label className={classes.label} htmlFor="toDate">
                                    End Date
                                </label>
                                <input
                                    className={classes.input}
                                    id="toDate"
                                    type="date"
                                    name="toDate"
                                    onChange={(e) => SetInputData({ ...inputData, endDate: e.target.value })}
                                    value={inputData.endDate}
                                    min={inputData.startDate || undefined}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-center">
                            <input type="submit" className="btn btn-primary form-controll mt-0" value={apiloader ? "Loading…" : "Submit"} disabled={apiloader}/>
                        </div>
                    </form>
                </div>
            </div>
            {
                apiloader ? (
                    <div className="TMLoader">
                        <Loader type="ThreeDots" color="#bd2f5e" height={80} width={80} />
                    </div>
                ) :
                    <>
                        <ReportResult
                            reports={reports}
                            setReports={setReports}
                            startDate={inputData.startDate}
                            endDate={inputData.endDate}
                            userid={DecryptED(userid)}
                            sid={DecryptED(sid)}
                        />
                        {reports.length > 0 ?
                        <nav aria-label="Page navigation example" className="container">
                            <ul className="pagination justify-content-end">
                                <li className={`page-item ${inputData.page <=1? 'disabled':''}`}>
                                    <button type="button" className="page-link" disabled={inputData.page <= 1} onClick={()=>{SetInputData({...inputData, page: inputData.page-1});}}>Previous page</button>
                                </li>
                                <li className={`page-item ${reports.length < inputData.pageSize ? 'disabled':''}`}>
                                    <button type="button" className="page-link" disabled={reports.length < inputData.pageSize} onClick={()=>{SetInputData({...inputData, page: inputData.page+1});}}>Next page</button>
                                </li>
                            </ul>
                        </nav>:""}
                    </>
            }
        </div>
    )
}

export default AdminWeeklyReport;

const useStyles = makeStyles({
    mainDiv: {
        marginTop: "0px",
        backgroundColor: "#f4f6fb",
        minHeight: "100vh",
        paddingBottom: "24px",
    },
    heading: {
        margin: "0",
        padding: "0",
        textAlign: "center",
        height: "45px",
    },
    filterCard: {
        maxWidth: "1000px",
        margin: "24px auto",
        backgroundColor: "#fff",
        borderRadius: "16px",
        boxShadow: "0 1px 2px rgba(15,23,42,0.06), 0 8px 24px rgba(15,23,42,0.06)",
        padding: "24px",
    },
    dateDiv: {
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
    },
    input: {
        width: "100%",
        height: "40px",
        padding: "0 12px",
        backgroundColor: "#fff",
        color: "#1f2937",
        border: "1px solid #e2e8f0",
        borderRadius: "10px",
        fontSize: "0.95rem",
    },
    label: {
        display: "block",
        fontSize: "13px",
        fontWeight: 600,
        color: "#1f2937",
        marginBottom: "6px",
        textAlign: "left",
    },
    form: {
        margin: "10px 0px",
    },
    button: {
        margin: "20px 0px",
        backgroundColor: "#42A0EA",
        padding: "6px 18px",
        color: "white",
    },
});